import { a11y } from './a11y';
import { aBasisNavigation } from '../components/static/basisNavigation';
import { aBasisNavigationMobile } from '../components/static/basisNavigationMobile';
import { aButton } from '../components/atoms/button';
import { aGrid } from '../components/helper/grid';
import { aHeader } from '../components/static/basisHeader';
import { aSearch } from '../components/static/basisSearch';
import { aSearchResults } from '../components/static/basisSearchResults';
import { atomGoogleMaps } from '../components/atoms/atomGoogleMaps';
import { blockAccordion } from '../components/flexible/blockAccordion';
import { blockTable } from '../components/flexible/blockTable';
import { atomIcon } from '../components/atoms/atomIcon';
import { checkboxList } from '../components/atoms/checkboxList';
import {
  initDelayedAnimations,
  initViewportRelatedAnimations
} from './animations';
import { lazyLoading } from './lazyLoading';
import { lockHeaderOnSmoothScroll } from './smoothScrolling';
import { atomYouTubePlayer } from '../components/atoms/atomYouTubePlayer';
import { basisFooter } from '../components/static/basisFooter';
import { blockImageInteractive } from '../components/flexible/blockImageInteractive';
import { heroCtaElements } from '../components/atoms/heroCtaElements';
import { blockArchiveBlog } from '../components/flexible/blockArchiveBlog';
import { atomInput } from '../components/atoms/input';
import { UsercentricsCmp } from '../components/helper/usercentricsCmp';
import { columnsTariffs } from '../components/flexible/columnsTariffs';
import { updateThemeShadows } from './themes';
import { aBasisBreadcrumbs } from '../components/static/basisBreadcrumbs';
import { aBasisPreHeader } from '../components/static/basisPreHeader';
import { blockArchiveDownloads } from '../components/flexible/blockArchiveDownloads';
import { blockGallery } from '../components/flexible/blockGallery';
import { blockEmbed } from '../components/flexible/blockEmbed';
import { atomDownloadTeaser } from '../components/atoms/atomDownloadTeaser';
import { handleMailAndPhoneButtons } from './helper';
import { aBasisCrisisManagement } from '../components/static/basisCrisisManagement';
import { basisShortcut } from '../components/static/basisShortcut';
import { blockJumpmarks } from '../components/flexible/blockJumpmarks';
import { blockDhlRetoure } from '../components/flexible/blockDhlRetoure';
import { blockCtaDynamic } from '../components/flexible/blockCtaDynamic';
import { atomTeaser } from '../components/atoms/atomTeaser';
import { blockDynamicTariffChart } from '../components/flexible/blockDynamicTariffChart';
import { atomTariffCalculator } from '../components/atoms/atomTariffCalculator';

declare global {
  interface Window {
    fvUsercentrics: UsercentricsCmp;
  }
}

export const init = () => {
  /** Execute first */
  window.fvUsercentrics = new UsercentricsCmp();

  /** Execute second */
  aBasisNavigation();
  aBasisNavigationMobile();
  aBasisCrisisManagement();
  aButton();
  atomInput();
  checkboxList();
  atomIcon();
  aGrid();
  aHeader();
  aSearch();
  aSearchResults();
  atomGoogleMaps();
  aBasisPreHeader();
  aBasisBreadcrumbs();
  atomYouTubePlayer();
  blockAccordion();
  blockTable();
  basisShortcut();
  basisFooter();
  blockImageInteractive();
  blockJumpmarks();
  heroCtaElements();
  blockArchiveBlog();
  blockArchiveDownloads();
  columnsTariffs();
  updateThemeShadows();
  blockGallery();
  blockEmbed();
  atomDownloadTeaser();
  blockDhlRetoure();
  blockCtaDynamic();
  atomTeaser();
  blockDynamicTariffChart();
  atomTariffCalculator();

  /** Animations */
  lockHeaderOnSmoothScroll();
  initDelayedAnimations();
  initViewportRelatedAnimations();

  /** Execute last */
  lazyLoading();
  handleMailAndPhoneButtons();
  a11y();
};
